import React from 'react';

import { FilterField, InfoItem, RelatedContentModal } from '@molecules';
import { NO_MARGIN_BOTTOM } from '@constants';
import { formatNotFoundError } from '@utils';
import { FILTER_TYPE } from '@api/filters/constants';

const RelatedAthleticsSkillModal = ({ visible, hide, onSubmit }) => (
  <RelatedContentModal
    visible={visible}
    hide={hide}
    title="Add related athletics skill"
    okText="ADD ATHLETICS SKILL"
    onSubmit={({ entity }) => onSubmit(entity)}
  >
    <FilterField
      name="entity"
      label="Choose an athletics skill"
      queryVariables={{ typeId: FILTER_TYPE.ATHLETICS_DISCIPLINE.id }}
      style={NO_MARGIN_BOTTOM}
      rules={[{ required: true, message: 'Athletics skill is required' }]}
    />
  </RelatedContentModal>
);

const Item = (entity) => {
  if (entity instanceof Error) {
    const error = entity;
    return <InfoItem>{formatNotFoundError({ error })}</InfoItem>;
  }

  return <InfoItem>{entity.title}</InfoItem>;
};

RelatedAthleticsSkillModal.Item = Item;

export default RelatedAthleticsSkillModal;
